import { useContext, useState } from "react";
import { LocaleContext, LoginContext, OverlayContext, StateContext } from "./App";
import { loginFunc, postWithCsrf } from "./util";
import { TwoFactorAuth } from "./TwoFactorAuth";
import './TwoFactorAuthLogin.css'
import { Navigate } from "react-router-dom";
import { LoadState } from "./enums.mjs";
import { ClosePopup, LoadButton, NavigateSmart } from "./Common";
import { useIndexUpdate, useReCaptcha } from "./hooks";

export function TwoFactorAuthLogin(props) {
    const state = useContext(StateContext);
    const login = useContext(LoginContext);
    const locale = useContext(LocaleContext);
    const overlay = useContext(OverlayContext);

    const [errorText, setErrorText] = useState("");
    const [loadState, setLoadState] = useState(LoadState.NONE);

    useIndexUpdate(props.indexUpdate, locale);

    const fetchReCaptchaToken = useReCaptcha();


    // FUNCTIONS:

    function handle2faCodeEntered(code) {
        try {
            let displayErrorObj = {displayError: true};

            Promise.resolve().then(() => {
                if(props.management) {
                    // No bot protection is required
                    return {token: null, url: "/user/management/login"};
                }
                else {
                    return fetchReCaptchaToken().then((token) => {
                        return {token: token, url: "/user/login"};
                    }).catch((error) => {
                        throw error;
                    });
                }
            }).then(({token, url}) => {
                return loginFunc(login.username, login.password, code, state, login, url, token, overlay, locale, displayErrorObj);
            }).then((json) => {
                setLoadState(LoadState.LOAD_SUCCESS);

                setErrorText(
                    <div className="text_success">
                        {locale.msgs.CODE_VALID}
                    </div>
                );

                login.setDisplayRememberDevice(true);

                login.setPassword("");
                props.onLogin(json);
            }).catch((error) => {
                console.log("Login ERROR: " + error);

                if(displayErrorObj.displayError) {
                    setLoadState(LoadState.LOAD_ERROR);

                    setErrorText(
                        <div className="text_error">
                            {locale.msgs.INVALID_CODE}
                        </div>
                    );
                }
                else {
                    setLoadState(LoadState.NONE);
                }
            });

            // Calling setLoadState() afterwards as it could throw an exception
            setLoadState(LoadState.LOADING);
            setErrorText("");
        }
        catch(e) {
            console.log(e);
        }
    }

    function handle2faCodeChange() {
        setErrorText("");
    }


    // RENDER:

    const credsValid = login.username != "" && login.password != "";

    return(
        credsValid ? 
        <div id="two_factor_auth_login">
            <TwoFactorAuth on2faCodeEntered={handle2faCodeEntered} on2faCodeChange={handle2faCodeChange}
                    twoFactorType={login.twoFactorAuthType} nextSmsCountS={login.nextSmsCountS}
                    username={login.username} password={login.password}
                    management={props.management} />

            { loadState === LoadState.LOADING ?
                <div className="loader margin_top_low"></div>
            :
                null
            }

            <div className="margin_top_low_low">{errorText}</div>
            
        </div>
        :
        <NavigateSmart to={ props.management ? "/login" : "/login/"}/>
    );
}
